"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiSkeletonThemeOptions = void 0;
exports.MuiSkeletonThemeOptions = {
    defaultProps: { animation: "wave" },
};
